'use strict'

export const copyShareStory = (() => {
    const init = () => {
        const dataTaskShareButtons = document.querySelectorAll('[data-story-share]')
        
        dataTaskShareButtons.forEach(button => {
            button.addEventListener('click', () => {
                const textToCopy = button.dataset.storyShare;

                navigator.clipboard.writeText(textToCopy).then(() => {
                  button.innerHTML = 'Gekopieerd naar klembord!'

                  setTimeout(() => {
                    button.innerHTML = 'Deel mijn veranderverhaal'
                  }, 2000)
                })
            })
        })
    }

    return {
        init
    }
})()